module.exports = __webpack_public_path__ + "static/media/1010.92755cc8.svg";